import instance from '../utils/axios';

class ThreadService {
	async transfer(clueId) {
		return await instance.post('/crm/clue/transferToSaleChance', {
			clueId: clueId
		});
    }
	async getClueById(clueId) {
		return await instance.get('/crm/clue/getClueById?uuid=' + clueId);
	}
	async distribution(newAdvisorId,ids) {
		return await instance.post('/crm/clue/distribution', {
			newAdvisorId: newAdvisorId,
		    ids: ids
		});
	}
    async getList(pageIndex, keyword, status,searchParam,startContactTime,finishContactTime,startCreateTime,finishCreateTime,source) {
		let data = {
            pageSize: 10,
            pageIndex: pageIndex,
            dictionaryNames: 'advisorId.base_staff,advisorId.base_staff.avatar,creatorId.base_staff,creatorId.base_staff.avatar,status.dict_clue_status',
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            fuzzySearch: keyword,
            sortField: 'IFNULL(disAdvisorTime,IFNULL(lastUpdateTime,createTime)) desc',
            status: status,
			// "searchField_dictionary_source":source,
			"searchField_datetime_createTime":(startCreateTime === "" && finishCreateTime === "" ? "" : (startCreateTime !== "" ? startCreateTime+" 00:00" : "") + "|" + (finishCreateTime !== "" ? finishCreateTime+" 23:59" : "")),
			"searchField_datetime_disAdvisorTime":(startContactTime === "" && finishContactTime === "" ? "" : (startContactTime !== "" ? startContactTime+" 00:00" : "") + "|" + (finishContactTime !== "" ? finishContactTime+" 23:59" : "")),
        }
		_.each(searchParam, function (index, item) {
		    data[item] = searchParam[item];
		});
        return await instance.post('/crm/clue/getClueList', data);
    }
    async getCluePool(pageIndex, keyword) {
		let data = {
            pageSize: 10,
            pageIndex: pageIndex,
            dictionaryNames: 'advisorId.base_staff,advisorId.base_staff.avatar,creatorId.base_staff,creatorId.base_staff.avatar,status.dict_clue_status',
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            fuzzySearch: keyword,
            sortField: 'createTime',
            sort: 'desc',
        }
        return await instance.post('/crm/clue/getCluePool', data);
    }

    async del(id) {
        return await instance.post('/crm/clue/deleteClue',{ids:id});
    }
    async close(id) {
        return await instance.post('/crm/clue/close',{ids:id});
    }
    async extract(id) {
        return await instance.post('/crm/clue/extract',{clueIds:id});
    }
    async assign(staffId,clueId) {
        return await instance.post('/crm/clue/distribution',{ids:clueId,newAdvisorId:staffId});
    }
    async translate(clueId) {
        return await instance.post('/crm/clue/translateClueToSaleChance',{ids:clueId});
    }
    async updateClueStatus(clueId,status) {
        return await instance.post('/crm/clue/updateClueStatus',{clueId:clueId,status:status});
    }
	async getOptions(dictionaryName) {
	    return await instance.post(`/crm/common/CommonApi/GetZLSelectDict?dictionaryName=${dictionaryName}&isFull=true`);
	}

}

export default new ThreadService();